var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { setNestedProperties } from "../actions/templateActions";
import { Field } from 'react-redux-form';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Icon } from "../../UI";
import { Translate } from "../../I18N";
import ViolatedArticlesNestedProperties from "./ViolatedArticlesNestedProperties";
import PropertyConfigOptions from "./PropertyConfigOptions";
import { checkErrorsOnLabel } from "../utils/checkErrorsOnLabel";

class FormConfigNested extends Component {
  constructor(props) {
    super(props);
    props.setNestedProperties(props.index, Object.keys(ViolatedArticlesNestedProperties));
  }

  render() {
    const { index, type, labelHasError } = this.props;

    return /*#__PURE__*/(
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx("div", { className: `form-group${labelHasError ? ' has-error' : ''}` }, void 0, /*#__PURE__*/
      _jsx("label", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Label")
      ), /*#__PURE__*/
      _jsx(Field, { model: `template.data.properties[${index}].label` }, void 0, /*#__PURE__*/
      _jsx("input", { className: "form-control" })
      )
      ), /*#__PURE__*/

      _jsx(Field, { model: `template.data.properties[${index}].required` }, void 0, /*#__PURE__*/
      _jsx("input", { id: `required${this.props.index}`, type: "checkbox" }), "\xA0", /*#__PURE__*/

      _jsx("label", { className: "property-label", htmlFor: `required${this.props.index}` }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Required property"), /*#__PURE__*/
      _jsx("span", { className: "property-help" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "question-circle" }), /*#__PURE__*/
      _jsx("div", { className: "property-description" }, void 0, /*#__PURE__*/
      _jsx(Translate, { translationKey: "empty property tip" }, void 0, "You won't be able to save an entity if this property is empty."

      )
      )
      )
      )
      ), /*#__PURE__*/
      _jsx(PropertyConfigOptions, { index: index, type: type })
      ));

  }
}

FormConfigNested.defaultProps = {
  labelHasError: false
};










function mapStateToProps(state, props) {
  return {
    labelHasError: checkErrorsOnLabel(state, props)
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ setNestedProperties }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(FormConfigNested);